import { IconProps } from "@/types/components/icons";

export function HomeIcon(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3052_2711" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3052_2711)">
        <path
          d="M5 15.8333H7.78854V10.8814H12.2115V15.8333H15V8.3333L10 4.56726L5 8.3333V15.8333ZM3.75 17.0833V7.7083L10 3.00476L16.25 7.7083V17.0833H10.9615V12.1314H9.03854V17.0833H3.75Z"
          fill={props.color || "#FFF"}
        />
      </g>
    </svg>
  );
}
